<template>
  <div class="LKPublicationsDataCollectionRight">
    <div class="LKPublicationsDataCollectionRight__row">
      <div class="LKPublicationsDataCollectionRight__chart">
        <button
          v-if="isActionButtonVisible"
          class="LKPublicationsDataCollectionRight__chart__btn"
          @click="onOpenFormdataReportModal"
          v-text="btnText"
        />
        <button
          v-if="readonly"
          class="LKPublicationsDataCollectionRight__chart__btn"
          @click="onDownloadData"
          v-text="'Скачать данные'"
        />
        <div
          v-if="description"
          class="LKPublicationsDataCollectionRight__btn-text"
          v-html="description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { createLKPassportContextualDataModal } from '@/views/LKPassport/utils'
import { LkPassportStatus } from '@/typings/api/Passport'
import { createPassportReportModal } from '@/views/PassportsList/utils'
import { lkPassportPermissions as Permissions } from '@/helpers/enums/permission-models'

export default {
  name: 'LKPassportContextualDataRight',
  components: {
    // LKPublicationsDataCollectionStatsChart,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    onContextsUpdated: {
      type: Function,
      required: true,
    },
    onContextsSubmit: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },
  computed: {
    isActionButtonVisible() {
      if (this.readonly) {
        return this.$access(Permissions.list)
      }
      return true
    },
    description() {
      if (this.readonly) {
        return void 0
      }
      switch (this.data.status) {
        case LkPassportStatus.IN_PROGRESS:
          return 'Продолжите заполнение паспорта'
        case LkPassportStatus.SUBMITTED:
          return 'Вы можете отредактировать данные'
        case LkPassportStatus.NOT_STARTED:
          return 'Вы можете заполнить паспорт'
        default:
          return 'Открыт'
      }
    },
    btnText() {
      if (this.readonly) {
        return 'Посмотреть'
      }
      switch (this.data.status) {
        case LkPassportStatus.IN_PROGRESS:
          return 'Редактировать'
        case LkPassportStatus.SUBMITTED:
          return 'Редактировать'
        case LkPassportStatus.NOT_STARTED:
          return 'Заполнить'
        default:
          return 'Открыт'
      }
    },
  },
  methods: {
    async onOpenFormdataReportModal() {
      const propsData = {
        data: this.data,
        readonly: this.readonly,
        onContextsUpdated: this.onContextsUpdated,
        onContextsSubmit: this.onContextsSubmit,
      }
      const modal = await createLKPassportContextualDataModal(this, propsData)
      await modal.open()

      // Это тут нужно, так как таблица строится
      // динамически и следит за id, если не чистить это говно,
      // то будут дубликаты, и таблица начнет ломаться
      modal.$destroy()
      modal.$el.parentNode.removeChild(modal.$el)
    },
    async onDownloadData() {
      const propsData = {
        params: { isList: false, passportId: this.data.id },
        title: 'Отчет',
      }
      const modal = await createPassportReportModal(this, propsData)
      await modal.open()

      modal.$destroy()
      modal.$el.parentNode.removeChild(modal.$el)
    },
  },
}
</script>

<style lang="scss">
$right-width: 280px;

.LKPublicationsDataCollectionRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: $right-width;
  // text-align: center;

  &__row {
    display: flex;
    width: 100%;
  }

  &__stats {
    width: 100%;
    font-size: 12px;
    text-align: left;
  }

  &__bottom-text {
    margin-top: 8px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
    text-align: center;
  }

  &__btn {
    padding: 8px 16px;
    margin: 4px;
    font-size: 12px;
    font-weight: 600;
    color: $webflow-color-white;
    background-color: $webflow-color-blue-dark;
    border-radius: 100px;
    transition: background-color $webflow-transition;

    &:hover {
      background-color: $webflow-color-blue-dark-hover;
    }

    &[disabled] {
      background-color: $webflow-color-grey;
    }

    & + & {
      margin-left: 12px;
    }

    &-text {
      margin-right: 8px;
    }
  }

  &__chart {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__btn {
      @extend .LKPublicationsDataCollectionRight__btn;

      & + & {
        margin: 4px;
      }
    }
  }
}
</style>
